export const EMPLOYEE_CENTER = {
  TITLE: 'Employee Center',
  BACK_TO_HOME: 'Go Back',
  TOOLS: {
    TITLE: 'Tools',
    PASSWORD_MANAGER: 'Password Manager',
    BROWSER_EXTENSION: 'Browser Extension',
    EDR_AGENT: 'EDR Agent',
    MDM_MOBILE: 'MDM Mobile',
    MDM_DIALOG: {
      TITLE: 'Turn on MDM',
      DESCRIPTION: 'Enroll your phone in mobile device management',
      SELECT_PLATFORM: 'Select your platform',
      PLATFORMS: {
        IOS: 'iOS',
        ANDROID: 'Android',
      },
      IOS_UNAVAILABLE: 'Company iPhones are set up by your IT team',
      STEPS: {
        SCAN_QR: 'Scan to open the enrollment page',
        SET_UP_WORK_PROFILE: 'Select Enroll and follow the steps to set up your work profile',
        CHECK_WORK_APPS: 'Your work apps now show a briefcase icon',
      },
    },
  },
  DOCUMENTATION: {
    TITLE: 'Documentation',
    PASSWORD_MANAGER_HANDBOOK: 'Password Manager Handbook',
    INSTALLING_AGENT: 'Installing the Agent',
    INSTALLING_CHROME_EXTENSION: 'Installing Google Chrome Extension',
    INSTALLING_MDM_MOBILE: 'Installing MDM Mobile',
  },
  POLICIES: {
    TITLE: 'Policies',
    SEARCH_PLACEHOLDER: 'Search policies',
    SIGN_ALL_POLICIES: 'Sign All Policies',
    READ_POLICY: 'Read policy',
    SIGNED_MESSAGE: 'You have signed all policies on',
    CLOSE: 'Close',
    ERROR_LOADING_POLICY: 'Error loading policy',
    LOADING: 'Loading…',
    NO_CONTENT_AVAILABLE: 'No content available',
    POLICY_NOT_AVAILABLE: 'Policy not available',
    CUSTOM_FILES: 'Custom Files',
    CUSTOM_LINKS: 'Custom Links',
    SIGN: 'Sign',
    ATTESTATION: 'I have read and accept this policy',
    STATUS_SIGNED: 'Signed',
    STATUS_UNSIGNED: 'Unsigned',
    STATUS_OUTDATED: 'Re-sign',
    STATUS_OUTDATED_ADMIN: 'Outdated',
    OF: 'of',
    SIGNED_COUNT_LABEL: 'signed',
  },
  ERRORS: {
    LOADING_EMPLOYEE_DATA: 'Error loading employee data',
  },
  FOREIGN_ORGANIZATION: {
    TITLE: 'Nothing to show here',
    DESCRIPTION:
      'The Employee Center shows your own policies and tools. You are viewing {organization} as an admin, so you have none here.',
    HINT: 'To review an employee, open the employee dashboard and select them to see their details and policies.',
    OPEN_DASHBOARD: 'Open employee dashboard',
    GO_BACK: 'Go back',
  },
}
